import { LoanForm } from './components/LoanForm';

interface OnboardingPageProps {
  onComplete: () => void;
}

export function OnboardingPage({ onComplete }: OnboardingPageProps) {
  return (
    <div className="stack">
      <div>
        <h1>Set Up Your Loan</h1>
        <p>
          Let's start with what you currently know about your LIC HFL home loan. You don't need a sanction letter
          or KFS yet — enter your best current expectation, and you can refine it later.
        </p>
      </div>
      <LoanForm onSaved={onComplete} />
    </div>
  );
}
